import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from './ThemeContext';
import { SmartInsightsProvider } from './SmartInsightsContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <SmartInsightsProvider>
        <App />
      </SmartInsightsProvider>
    </ThemeProvider>
  </React.StrictMode>
);
